import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  // Initialize Meta Pixels (two accounts)
  useEffect(() => {
    if ((window as any).__fbPixelInitialized) return;
    (window as any).__fbPixelInitialized = true;
    if (window.fbq) {
      window.fbq('init', '1379391876531260');
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: any = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = false;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window.fbq('init', '855275007473565');
    window.fbq('init', '1379391876531260');
    window.fbq('track', 'PageView');
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }, []);
  // Track scroll-based pixel events (fire each only once, to BOTH pixels)
  useEffect(() => {
    const firedEvents = new Set<string>();
    const fireOnce = (eventName: string, params: Record<string, any>) => {
      if (firedEvents.has(eventName) || !window.fbq) return;
      firedEvents.add(eventName);
      window.fbq('track', eventName, params);
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const id = entry.target.id;
        if (id === 'pricing') {
          fireOnce('ViewContent', {
            content_name: 'El Código de Identidad 1.0 - Pricing',
            content_type: 'product',
            value: 6.39,
            currency: 'USD'
          });
        }
        if (id === 'garantia') {
          fireOnce('AddToWishlist', {
            content_name: 'El Código de Identidad 1.0',
            content_type: 'product',
            value: 6.39,
            currency: 'USD'
          });
        }
        if (id === 'cta-final') {
          fireOnce('Lead', {
            content_name: 'El Código de Identidad 1.0',
            content_type: 'product',
            value: 6.39,
            currency: 'USD'
          });
        }
      });
    }, {
      threshold: 0.3
    });
    const timer = setTimeout(() => {
      const sections = ['pricing', 'garantia', 'cta-final'];
      sections.forEach(id => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    }, 500);
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);
  return <SalesPage data-id="element-0" />;
}